export { conditional as default, whenProps } from '@loadsmart/loadsmart-ui/dist/tools';
